import { render, staticRenderFns } from "./WishListBtn.vue?vue&type=template&id=08a52cb8&"
import script from "./WishListBtn.vue?vue&type=script&lang=js&"
export * from "./WishListBtn.vue?vue&type=script&lang=js&"
import style0 from "./WishListBtn.vue?vue&type=style&index=0&id=08a52cb8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports